import { action, observable } from 'mobx';

import { TextMessageWithTranslation } from '../models';
import { MESSAGE_TYPE_RECEIVED } from '../utilities';

export default class ChatStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  @observable messages = [];

  @observable isMessaging = false;

  @observable isUserMessage = false;

  @observable isWelcomeMessage = false;

  @observable isSpecialMessage = false;

  @observable liveChatTag = {
    online: '',
    offline: ''
  };

  @observable liveChatTriggers = {
    catid: '',
    triggerid: ''
  };

  @action addMessage(message) {
    this.messages.push(message);
    if (!this.isUserMessage && message.type === 1) {
      this.isUserMessage = true;
    }
  }

  @action clearMessages() {
    this.messages.clear();
    this.isUserMessage = false;
    this.rootStore.bot.noAnswersCount = 0;
    this.isWelcomeMessage = false;
    this.isSpecialMessage = false;
    localStorage.setItem('MesIndexCount', 0);

    if (document.querySelector('#chatHist')) {
      document.querySelector('#chatHist').remove();
      this.addMessage(
        new TextMessageWithTranslation({
          content: this.rootStore.config.chatHistoryWelcome,
          type: MESSAGE_TYPE_RECEIVED
        })
      );
    }

    if (
      this.rootStore.config.projectSelector?.enabled &&
      window.location.href
        .toLowerCase()
        .indexOf(this.rootStore.config.projectSelector.detectURL1) <= 0 &&
      window.location.href
        .toLowerCase()
        .indexOf(this.rootStore.config.projectSelector.detectURL2) <= 0
    ) {
      this.rootStore.ui.project.isSelected = false;
      this.rootStore.ui.project.id = 0;
      this.rootStore.ui.project.projectId = 0;
      this.rootStore.ui.project.source = '';
      this.rootStore.bot.topFrequentQuestions = [];
    }
    if (this.rootStore.config.headerMenu?.enabled && this.rootStore.ui.category.id) {
      this.rootStore.ui.category.isCleared = true;
    }
  }

  @action updateMessages() {
    this.messages.clear();
    this.isUserMessage = false;
    this.rootStore.bot.noAnswersCount = 0;
    this.isWelcomeMessage = false;
    localStorage.setItem('MesIndexCount', 0);
  }

  @action setLiveChatTag(online, offline) {
    this.liveChatTag.online = online;
    this.liveChatTag.offline = offline;
  }

  @action setLiveChatTriggers(catid, triggerid) {
    this.liveChatTriggers.catid = catid;
    this.liveChatTriggers.triggerid = triggerid;
  }
}
